import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 mb-4 mb-lg-0">
            <div className="footer-logo">
              <img src="/images/logo_image.webp" alt="FundMeWiz" />
            </div>
            <p className="footer-description">
              FundMeWiz is the best give and save fundraising platform, helping organizations 
              and individuals achieve their fundraising goals.
            </p>
          </div>

          <div className="col-lg-2 col-md-4 mb-4 mb-md-0">
            <h6 className="footer-title">Quick Links</h6>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact</Link></li>
              <li><Link to="/fundmewiz-app">Download App</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-4 mb-4 mb-md-0">
            <h6 className="footer-title">Legal</h6>
            <ul className="footer-links">
              <li><Link to="/terms-of-use">Terms of Use</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-4">
            <h6 className="footer-title">Get Started</h6>
            <ul className="footer-links">
              <li><Link to="/login">Sign In</Link></li>
              <li><Link to="/register">Start a Campaign</Link></li>
            </ul>
            <div className="social-links">
              <a href="#" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} FundMeWiz. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
